export default __webpack_public_path__ + "static/media/cage.5e5793d2.JPG";